import { defaultIconSizeMedium } from '../types';

type Props = {
  size?: number;
};

// biome-ignore-start lint/plugin/no-hex-color: brand logo colors
export const MicrosoftIcon = ({ size = defaultIconSizeMedium }: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    width={size}
    height={size}
    aria-hidden="true"
  >
    <path d="M0 0h7.58v7.58H0z" fill="#F25022" />
    <path d="M8.42 0H16v7.58H8.42z" fill="#7FBA00" />
    <path d="M0 8.42h7.58V16H0z" fill="#00A4EF" />
    <path d="M8.42 8.42H16V16H8.42z" fill="#FFB900" />
  </svg>
);
// biome-ignore-end lint/plugin/no-hex-color: brand logo colors
